const g = (s) => {
  if (!/^[0-9:]*$/.test(s))
    return !1;
  const i = a(s), [r, o] = i.split(":"), e = Number(r), n = Number(o ?? 0), u = e >= 0 && e <= 24, l = n >= 0 && n <= 59;
  return u && l;
}, a = (s) => {
  let t = s.replace(/:/g, "");
  return t.length === 1 && !["0", "1", "2"].includes(t) && (t = t.padStart(2, "0")), t.length <= 2 ? t : `${t.substring(0, 2)}:${t.substring(2, 4)}`;
};
export {
  a as formatWithPattern,
  g as validationValue
};
//# sourceMappingURL=tools.js.map
